<template>
  <div class="container-fluid" v-if="authorised && user != null" style="z-index: 99999">
    <div class="row nav-container">
<!--      <div class="col-12">-->
      <img class="logo-container" src="/static/img/logo-white.svg" height="30px">
        <ul>
          <li style="display: none;"><router-link to="/home" exact >Home</router-link></li>


          <li v-if="canAccessOrderPage() === true"><router-link to="/orders">ORDERS</router-link></li>
          <li v-if="canAccessProductPage() == true"><router-link to="/products">PRODUCTS</router-link></li>
          <li v-if="canAccessShopPage() == true"><router-link to="/merchants">SHOPS</router-link></li>
          <li v-if="canAccessVendorsPage() == true"><router-link to="/vendors?type=vendor" exact>VENDORS</router-link></li>
          <li v-if="canAccessVendorOrderPage() == true"><router-link to="/vendorOrders" exact>Ven Ords</router-link></li>
          <li v-if="canAccessSupplierPage() == true"><router-link to="/vendors?type=supplier" exact>SUPPLIERS</router-link></li>

          <li v-if="isAdmin() == true"><router-link to="/setting">SETTINGS</router-link></li>
          <li v-if="canAccessCreditPage() == true"><router-link to="/credits">CREDITS</router-link></li>
          <li v-if="canAccessReportPage() == true"><router-link to="/report">STATISTICS</router-link></li>

          <li v-if="canAccessNotification() == true"><router-link to="/notifier">NOTIFICATIONS</router-link></li>
          <li v-if="isMallManager() == true"><router-link to="/commerce">COMMERCE</router-link></li>
          <li>
            <i class="fas fa-sign-out-alt logout-btn" v-on:click="logout"></i>
          </li>
        </ul>
<!--      </div>-->
    </div>

    <transition name="slideup">
      <div class="item-container" v-if="historyView != false" style="z-index:5; padding-bottom: 100px;" v-on:click="closeHistoryView">
        <div class="card" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); height: 90%; width:80%;" v-on:click.stop="dummy">
          <div class="card-header text-right" style="position: sticky; top:0; z-index:10; background-color: #D2D2D2;">
            <span style="float:left;"><strong>{{historyView.title}}</strong></span>

          </div>
          <div class="card-body" style="padding-left: 0; padding-right: 0;">
            <table class="table">
              <tr>
                                <th>#</th>

                <th>Date/Time</th>
                <th>By</th>
                <th>Order ID</th>
                <th>Order Item ID</th>
                <th></th>
                <th class="text-left">Content</th>


              </tr>
              <tr v-for="s in historyView.items">
                                <td>{{s.id}}</td>
                <td>{{timeString(s.createdTimestamp)}}</td>
                <td>{{s.userName}}</td>
                <td>{{s.orderId}}</td>
                <td>{{s.orderItemId}}</td>
                <td class="text-left"><span v-if="s.header !== null && s.header.length > 0">{{s.header}}</span></td>
                <td class="text-left" v-html="s.description"></td>


              </tr>
            </table>
          </div>
          <div class="card-footer text-left">


            <button class="btn btn-dark" style="float:right;" v-on:click="closeHistoryView">Close</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="slideup">
      <order-item-tracking-view v-if="orderTrackingItem !== false"
        :item="orderTrackingItem"
      :on-close="closeOrderTracking">

      </order-item-tracking-view>
    </transition>
    <v-dialog/>

    <transition name="dissolve">
      <div class="progressView" v-if="isLoading==true">
        <div class="center-container">
          <div class="content-center">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <p class="loading-message"> {{loadingMessage}}</p>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
    import {getUserByToken} from "../api/user";

    require('@/assets/css/loading1.css')
    import Router from '../router';
    import EventBus from '../api/event-bus.js';
    import {getHistory} from "../api/history";
    import {millisToReadable, showDialog} from "../api/utils";
    import OrderItemTrackingView from "./ItemView/OrderItemTrackingView.vue";
    export default {
        name: "TopNav",
        data() {
            return {
                authorised: false,
                isLoading:false,
                loadingMessage:'',
                user: null,
                historyView: false,
              orderTrackingItem: false,
            }
        },
      components: {
        OrderItemTrackingView
      },
        created() {
            EventBus.$on('logon', this.onLogged);
            EventBus.$on('showLoading', this.showLoading);
            EventBus.$on('showDialog', this.showDialog);
            EventBus.$on('sessionExpired', this.onExpired);
            EventBus.$on('getHistory', this.showHistory);
            EventBus.$on('getOrderItemTracking', this.showOrderTracking);
        },
        mounted() {
          this.$data.user = auth.getUser();
          // console.log("mounted authorised " + this.$data.authorised);
          // console.log(this.$data.user);
          if(this.$data.user !== null) {
            this.$data.authorised = true;
          }
        },
        methods: {
            timeString: millisToReadable,
            canAccessOrderPage: function() {
              if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
                return this.$data.user.accessOrder;
              }
              return false;
            },
          canAccessProductPage: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.accessProduct;
            }
            return false;
          },
          canAccessShopPage: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.accessShop;
            }
            return false;
          },
          canAccessCreditPage: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.accessCredit;
            }
            return false;
          },
          canAccessReportPage: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.accessReport;
            }
            return false;
          },
          canAccessVendorsPage: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.accessVendor;
            }
            return false;
          },
          canAccessVendorOrderPage: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.manageVendorOrders;
            }
            return false;
          },
          canAccessSupplierPage: function() {
             if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.accessSuppliers;
            }
            return false;
          },
          canAccessNotification: function() {
            if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_STAFF')) {
              return this.$data.user.manageNotification;
            }
            return false;
          },
            isAdmin: function() {
              if(this.$data.user != false && this.$data.user != null && this.$data.user.type === 'ROLE_ADMIN') {
                return true;
              }
              return false;
            },
            isManager: function() {
              if(this.$data.user != false && this.$data.user != null && (this.$data.user.type === 'ROLE_ADMIN' || this.$data.user.type === 'ROLE_MANAGER')) {
                return true;
              }
              return false;
            },
            isMallManager: function() {
              if(this.$data.user !== false && this.$data.user !== null && this.$data.user.type === 'ROLE_MALL_MANAGER') {
                return true;
              }
              return false;
            },
            onLogged: function(logged) {
                // console.log("logged on " + logged);
                this.$data.authorised = logged;
                let self = this;
                if(logged == false) {
                  this.onLogoutConfirmed();
                } else {
                  getUserByToken()
                    .then(function (user) {
                    self.$data.user = user;
                    auth.setUser(user);
                  })
                  .catch(function(err){

                  })
                  // this.$data.user = auth.getUser();
                  // console.log("logged on and get user ");
                  // console.log(this.$data.user);
                }
            },
            onExpired: function() {
              this.$data.authorised = false;
              this.$router.push('/');
            },
            logout: function () {
                let self = this;
                this.$modal.show('dialog', {
                    //title: '로그아웃',
                    text: '로그아웃 하시겠습니까?',
                    buttons: [
                        {
                            title: '아니요',
                            handler: () => {
                                self.$modal.hide('dialog');

                            }
                        },
                        {
                            title: '로그아웃',
                            handler: () => {
                                self.$modal.hide('dialog');
                                self.onLogoutConfirmed();
                            }
                        },

                    ]

                });
            },
            onLogoutConfirmed: function () {
                localStorage.removeItem("lastPage");
                localStorage.removeItem("JSTOKEN");
                localStorage.removeItem("email");
                localStorage.removeItem("id");
                localStorage.removeItem("password");
                localStorage.removeItem("autoLogin");
                this.$data.authorised = false;
                Router.push('/');
            },
            onSessionExpired: function() {
              this.$data.authorised = false;
              Router.push('/');
            },
            showLoading: function(show) {
              this.$data.isLoading = show;
            },
            showDialog: function(params) {
              this.$modal.show('dialog', params);
            },
            dummy: function() {

            },
            showHistory: function(title, message, query) {
              let self = this;
              console.log("show History " + title  + " " + message + " : " + query);
              getHistory(query)
              .then(function(data) {
                console.log("history response");
                console.log(data);
                if(data.success == true) {
                  self.$data.historyView = {
                    title: title,
                    message: message,
                    items: data.item,
                  };
                } else {
                  showDialog(data.message);
                }
              })
              .catch(function(err) {

              })
            },

            closeHistoryView: function() {
                this.$data.historyView = false;
            },
          showOrderTracking: function(id) {
              this.$data.orderTrackingItem =  {
                id: id,
              }
          },
          closeOrderTracking: function() {
              this.$data.orderTrackingItem = false;
          }
        }
    }
</script>

<style lang="css" scoped>
  .nav-container {
    /*background: #333;*/
    /*margin-bottom: 20px;*/
    height: 60px;
    background-image: linear-gradient(#969797, black);
    position: relative;
  }
  ul {
    display: flex;
    list-style-type: none;
    margin: auto;
    position: absolute;
    bottom: 0;
    left:50%;
    transform: translateX(-50%);
    padding: 0;
    overflow: hidden;
    background-color: transparent;
  }

  li {
    float: left;
  }

  li a {
    display: block;
    color: white;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    min-width: 100px;
  }
  @media only screen and (max-width: 380px) {
    li a {
      min-width: 100px;
    }
  }
  /* Change the link color to #111 (black) on hover */

  li a:hover:not(.active) {
    text-decoration: none;
    background-color: #111;
    color: white;
  }
  .active {
    background-color: #4CAF50;
  }
  .logo-container {
    position: absolute;
    top:10px;
    left:50px;
  }
  @media only screen and (max-width: 1080px) {
    .logo-container {
      display: none;
    }
  }
  .logout-btn {
    color:white;
    font-size:25px;
    line-height: 52px;
    padding-left: 20px;
    padding-right: 20px;
  }
  .router-link:hover {

  }
  .router-link-active {
    background-color: #2b90d9;
    border-color: #1982ce;
    color: #fefefe;
  }
  .nav-container .logo {
    width:100px;
    height: 150px;
    position: absolute;
    left: 0;
    top: 0;
    background-image: url("/static/mace_logo.png");
    background-position: left;
    background-repeat: no-repeat;
    background-size: 100px 100px;
  }
  @media all and (max-width: 1080px) {

    .nav-container li a {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue